<template>
  <!-- Modal: Select Stores -->
  <div :class="modal ? 'modal is-active' : 'modal'">
    <div class="modal-background"></div>
    <div class="modal-card is-medium">
      <header class="modal-card-head">
        <button @click="closeModal()" class="delete" aria-label="close"></button>
        <p class="modal-card-title">
          {{ search ? 'Select Stores' : 'Please enter location' }} 
        </p>
      </header>
      <section class="modal-card-body ph20">
        <div class="mb15">
          <div class="field">
            <div class="control has-icon">
              <gmap-autocomplete
               :value="search"
                class="nput has-bg-grey google-autocomplete"
                style="height: 2.625rem; padding: 10px 20px 10px 45px; color: #666666; font-size: 0.9375rem; background-color: #f9f9f9; box-shadow: none; border-radius: 4px; border: none; width: 100%;"
                large
                placeholder
                @place_changed="storeNearLocation"
                :select-first-on-enter="true"
              ></gmap-autocomplete>
              <span class="icon pointer" @click.prevent="locateUser()">
                <img src="@/assets/img/icon-location-purple.svg" alt="image" />
              </span>
            </div>
          </div>
        </div>
        <loading v-if="loading"></loading>
        <p
          v-else
          class="is-size-14 modal-text mb10"
        >
        <template v-if="activeInput">{{nearByStore.length}} Stores Near You</template></p>
        <div class="stores-list">
          <div
            class="store-item"
            @click="selectThisStore(item)"
            v-for="(item, num) in nearByStore"
            :key="num+'-store-list'"
          >
            <div class="store-logo">
             <img v-if="getStorefeaturedImage(item.images)" class="store-img" :src="getStorefeaturedImage(item.images)" >
            </div>
            <div class="store-detail">
              <div
                class="store-name has-text-weight-semibold is-uppercase is-flex justify-content-between align-items-center"
              >
                <p class="text-dark">{{item.display_name}}</p>
                <div class="distance text-dark" v-if="item.distance">{{item.distance +' KM'}}</div>
              </div>
              <div
                class="store-address mb5"
              >{{item.address_line_1}} {{item.address_line_2 ? ', ' + item.address_line_2:''}}</div>
              <div class="store-timings is-flex">
                <span :class="item.is_open ? 'status has-text-green' : 'status has-text-danger'">{{ item.is_open ? 'Open' : 'Close' }}&nbsp; • &nbsp;</span>
                <div v-html="getOpenCloseTime(item.location_hours)"></div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { isEmpty, find } from "lodash";
import { mapGetters, mapActions } from "vuex";
import LocationApis from '@/Components/Controllers/LocationApis.js';
import moment from "moment";

export default {
  name: "ProductDetailSelectStoreDropDown", // Not in use
  data() {
    return {
      modal: false,
      loading: false,
      nearByStore: [],
      search: '',
      locationObj: {},
    };
  },

  mounted() {
    bus.$on("show-modal-select-store", payload => {
      this.modal = payload;
    });
  },

  beforeDestroy() {
    bus.$off('show-modal-select-store');
  },

  computed: {
    ...mapGetters({
      vg_selectedLocation: "location/selected",
    }),

    activeInput() {
      if(_.isEmpty(this.locationObj)){
        return false;
      }
      return true;
    },
  },
  methods: {

    /**
     * Locate user via ip
     */
    async locateUser() {
      this.va_spinner(true);
      let res = await LocationApis.locateUser();
      this.va_spinner(false);
      if(res.status == 200) {
        // this.search = res.address;
        let obj = {
          geometry: {
            location: {
              lat: res.lat,
              lng: res.lng,
            }
          }
        }; // structure like gmap gives data
        this.storeNearLocation(obj);
      } 
    },
  
    /**
     * Nearby stores search
     */
    async storeNearLocation(addressData) {
      this.locationObj = addressData;
      this.loading = true;
      let res = await LocationApis.fetchNearest(_.isEmpty(addressData) ? '' : addressData.geometry, false);
      if(res.status == 200){
        this.nearByStore = res.data.payload.locations;
      } else {
        this.nearByStore = [];
      }
      this.loading = false;
    },

    /**
     * select the store
     */
    async selectThisStore(item) {
      if(this.vg_selectedLocation.id != item.id){
        this.va_setSelectedLocation(item);
        this.closeModal();
        this.$router.push({ name: 'StoreProfile', params: {store_slug: item.slug}})
        // Now fetch this locaiton cart
      } else {
        this.va_snackbar({
          message: 'This location is currently active',
        })
      }
    
    },


    getOpenCloseTime(item) {
      let schedule = _.find(item, function(o) { return o.dayName == moment().format("dddd"); });
      if(schedule != undefined){
        return `<span class="time">${ moment(schedule.open_time, "HH:mm:ss").format("hh:mm a") } - ${ moment(schedule.close_time, "HH:mm:ss").format("hh:mm a") }</span>`;
      }
      return '';
    },


    closeModal() {
      this.search = '';
      this.modal = false;
      this.nearByStore = [];
      this.locationObj = {};
    },

    /**
     * Get store fav image
     */
    getStorefeaturedImage(images) {
      if(images && images.length < 1){
        return '';
      }
      let featuredImage = _.find(images, { default: true});
      if(featuredImage == undefined){
        return '';
      }
      return featuredImage.url;
    },
    
    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
    })
  }
};
</script>